import { useNodeService } from "@fero/hooks";
import { tradeSalesKeys } from "../../query-keys";

interface GetSavedProductPricesQueryParams {
  organisationId: string;
  purchaserId: string | null;
}

export const useGetSavedProductPricesQuery = ({
  organisationId,
  purchaserId,
}: GetSavedProductPricesQueryParams) => {
  const nodeService = useNodeService();
  return nodeService.getProductSalePrices.useQuery(
    tradeSalesKeys.savedProductPrices(organisationId, purchaserId),
    {
      query: { organisationId, purchaserId },
    },
  );
};
